import {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";

// ЧАСТ К — С12: замени по състояние на одобрението.
//
// Смисълът ѝ е администраторът да вижда какво чака и какво е отказано, без да
// обхожда землище по землище. Особено важна е за землища, които не са зададени
// на никого — там няма кой друг да погледне.

const VIEWS = [
    {value: 'pending', label: 'Чакащи одобрение'},
    {value: 'approved', label: 'Одобрени'},
    {value: 'rejected', label: 'Отказани'},
    {value: 'undetermined', label: 'Към неопределени землища'},
];

const STATUS_LABEL = {
    pending: 'чака одобрение',
    approved: 'одобрена',
    rejected: 'отказана',
    deleted_far: 'изтрита отсреща',
    not_required: 'без одобрение',
};

export const ReportS12 = () => {
    const {year} = useParams();
    const request = requester();

    const [view, setView] = useState('pending');
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        setLoading(true);
        setError('');
        request.get(`${baseUrl()}/reports/s12/${year}?status=${view}`)
            .then(setData)
            .catch(err => setError(err.message || 'Грешка при зареждане на справката.'))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, view]);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h5 style={{color: "var(--app-gold)"}}>
                    С12 — Замени по състояние на одобрението
                </h5>
                <div className="btn-group flex-wrap">
                    {VIEWS.map(v => (
                        <button key={v.value} type="button"
                                className={`btn btn-sm ${view === v.value
                                    ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                onClick={() => setView(v.value)}>
                            {v.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="text-muted mb-2">Стопанска {year} година</div>

            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && data && data.count === 0 && (
                <p className="text-muted">Няма замени в тази категория.</p>
            )}

            {data && data.count > 0 && (
                <>
                    <div className="mb-2">Брой замени: <strong>{data.count}</strong></div>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="tableHead">
                            <tr>
                                <th>Дата и час</th>
                                <th>Въвел</th>
                                <th>Даващ</th>
                                <th>Взимащ</th>
                                <th className="text-end">Площ (дка)</th>
                                <th>От землище</th>
                                <th>За землище</th>
                                <th>Състояние</th>
                                <th>Произнесъл се</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.rows.map(r => (
                                <tr key={r.deal_id}>
                                    <td style={{whiteSpace: "nowrap"}}>{r.create_on}</td>
                                    <td>{r.user}</td>
                                    <td>{r.company_giving}</td>
                                    <td>{r.company_receiving}</td>
                                    <td className="text-end">{r.amount?.toFixed(2)}</td>
                                    <td>{r.settlement_giving}</td>
                                    <td>{r.settlement_receiving}</td>
                                    <td>
                                        {STATUS_LABEL[r.approval_status] || r.approval_status}
                                        {r.author_ack && ' (уредено)'}
                                        {r.reject_reason && (
                                            <div className="small text-muted">{r.reject_reason}</div>
                                        )}
                                    </td>
                                    <td style={{whiteSpace: "nowrap"}}>
                                        {r.decided_by || '—'}
                                        {r.decided_on && <div className="small text-muted">{r.decided_on}</div>}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    {view === 'rejected' && (
                        <div className="alert alert-warning mt-2">
                            Отказаната замяна <strong>остава в сила</strong> в землището, където е
                            създадена — отказът не отменя нищо там. Разминаването се урежда между
                            хората; системата само го показва.
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
